import { canvasPanelClassNames } from "../canvasTheme";
import type { DimensionMarkerStyle, SettingsPanelProps } from "../settingsPanelTypes";
import { Field, SelectField, TextInputField } from "./SettingsPanelFields";

const dimensionMarkerStyleOptions: Array<{ value: DimensionMarkerStyle; label: string }> = [
  { value: "filled-arrow", label: "2 - Freccia piena" },
  { value: "slash", label: "3 - Slash" },
  { value: "dot", label: "4 - Punto" },
];

type GeneralSettingsPageProps = Pick<
  SettingsPanelProps,
  | "gridSpacingDraft"
  | "onGridSpacingDraftChange"
  | "commitGridSpacingDraft"
  | "isGridSnapEnabled"
  | "onGridSnapEnabledChange"
  | "gridSnapStepDraft"
  | "onGridSnapStepDraftChange"
  | "commitGridSnapStepDraft"
  | "osnapTypes"
  | "enabledOsnaps"
  | "onOsnapToggle"
  | "entityLineWidth"
  | "onEntityLineWidthChange"
  | "previewLineWidth"
  | "onPreviewLineWidthChange"
  | "dimensionTextHeightDraft"
  | "onDimensionTextHeightDraftChange"
  | "commitDimensionTextHeightDraft"
  | "dimensionTextGapDraft"
  | "onDimensionTextGapDraftChange"
  | "commitDimensionTextGapDraft"
  | "dimensionMarkerStyle"
  | "onDimensionMarkerStyleChange"
>;

export function GeneralSettingsPage(props: GeneralSettingsPageProps) {
  return (
    <>
      <TextInputField
        label="Grid Spacing"
        inputMode="decimal"
        value={props.gridSpacingDraft}
        onChange={props.onGridSpacingDraftChange}
        onCommit={props.commitGridSpacingDraft}
      />
      <div className={canvasPanelClassNames.fieldLabel}>
        <label className={canvasPanelClassNames.checkboxRow}>
          <input
            type="checkbox"
            checked={props.isGridSnapEnabled}
            onChange={(event) => props.onGridSnapEnabledChange(event.target.checked)}
          />
          Snap to Grid
        </label>
        <TextInputField
          label="Grid Snap Step"
          inputMode="decimal"
          value={props.gridSnapStepDraft}
          onChange={props.onGridSnapStepDraftChange}
          onCommit={props.commitGridSnapStepDraft}
        />
      </div>
      <Field label=" Active OSNAPs">
        <div className="grid grid-cols-2 gap-1">
          {props.osnapTypes.map((osnapType) => (
            <label key={osnapType} className={canvasPanelClassNames.compactCheckboxRow}>
              <input
                type="checkbox"
                checked={props.enabledOsnaps[osnapType]}
                onChange={(event) => props.onOsnapToggle(osnapType, event.target.checked)}
              />
              {osnapType}
            </label>
          ))}
        </div>
      </Field>

      <TextInputField
        label="Dimension Text Height (px)"
        inputMode="numeric"
        value={props.dimensionTextHeightDraft}
        onChange={props.onDimensionTextHeightDraftChange}
        onCommit={props.commitDimensionTextHeightDraft}
      />
      <TextInputField
        label="Dimension Text Gap (px)"
        inputMode="decimal"
        value={props.dimensionTextGapDraft}
        onChange={props.onDimensionTextGapDraftChange}
        onCommit={props.commitDimensionTextGapDraft}
      />
      <SelectField
        label="Dimension Marker Style"
        value={props.dimensionMarkerStyle}
        options={dimensionMarkerStyleOptions}
        onChange={props.onDimensionMarkerStyleChange}
      />
    </>
  );
}
